import { ModalProps, CloseButtonProps, defaultTheme } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const dialogOverrides: NonNullable<ModalProps['overrides']> = {
  Header: {
    props: {
      position: 'absolute',
      top: 0,
      right: 0,
      backgroundColor: 'transparent',
      paddingTop: { _: '1rem !important', sm: '1rem' },
      paddingRight: { _: '1rem !important', sm: '1rem' }
    }
  },
  Body: { props: { padding: '0 !important' } }
};

export const drawerOverrides: NonNullable<ModalProps['overrides']> = {
  Content: {
    props: {
      borderTopLeftRadius: '12px',
      borderTopRightRadius: '12px',
      height: 'auto',
      boxShadow: '0px -7px 16px -8px #0000004D, 0px -10px 27px -5px #2C292540'
    }
  },
  Header: {
    props: {
      position: 'absolute',
      top: 0,
      right: 0,
      backgroundColor: 'transparent',
      paddingTop: '1rem !important',
      paddingRight: '1rem !important'
    }
  },
  Body: { props: { padding: '0 !important' } }
};

export const closeButtonOverrides: NonNullable<CloseButtonProps['overrides']> = {
  Root: {
    props: {
      borderRadius: '50%',
      height: `${pxToRem(36)}`,
      minWidth: `${pxToRem(36)}`,
      outline: `0.125rem solid ${defaultTheme.colors.transparent}`,
      padding: '0px !important',
      width: `${pxToRem(36)}`,
      background: { _: `${defaultTheme.colors.white} !important`, sm: 'transparent !important' },
      _focusVisible: {
        background: { _: `${defaultTheme.colors.white} !important`, sm: 'transparent !important' }
      },
      _hover: {
        background: { _: `${defaultTheme.colors.white} !important`, sm: 'transparent !important' }
      },
      _active: {
        background: { _: `${defaultTheme.colors.white} !important`, sm: 'transparent !important' }
      }
    }
  },
  Icon: {
    props: {
      color: defaultTheme.colors.black
    }
  }
};
